import type { OwnFxTransfer } from './OwnFxTransfer';

export const base: OwnFxTransfer = {
    isEnabledForSavingsAccounts: true,
    isCollectiveSigningInfoDisplayed: false,
};
